module.exports = "https://cdn.littlereply.com/tt/resource/earn_pool_coins.c3ef0f55146396b343e7a33146c03d9e.png";